var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElectricityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1133 0C16.6166 0 0 16.6162 0 37.1133C0 57.6103 16.6162 74.2266 37.1133 74.2266C57.6103 74.2266 74.2266 57.6103 74.2266 37.1133C74.2266 16.6162 57.6103 0 37.1133 0ZM32.6151 14.1214H47.2357L39.3634 33.2402H50.6098L25.8676 68.1042L33.74 39.988H23.6185L32.6151 14.1214Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricityIcon);
export default __webpack_public_path__ + "static/media/electricity-icon.f955b283d2dee6474baa495c38d00b69.svg";
export { ForwardRef as ReactComponent };